import { render, staticRenderFns } from "./Footprint.vue?vue&type=template&id=4b2e1d8c"
import script from "./Footprint.vue?vue&type=script&lang=js"
export * from "./Footprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports